module.exports = __webpack_public_path__ + "static/media/TBC.cbb68afa.jpg";